<script lang="ts">
    import type {Injector, LocalizeFunction} from '../../../svelte/types';
    import {getContext, onDestroy} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY} from '../../../svelte/utils';
    import type {Record} from '../../../typings/portaro.be.types';
    import {KpFavouritesButtonPresenter} from './kp-favourites-button.presenter';
    import {disabledWhen} from '../../../svelte/svelte-actions/disabled-when';
    import type {State} from '../../constants/portaro.constants';
    import {states} from '../../constants/portaro.constants';

    export let record: Record;

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);
    const presenter: KpFavouritesButtonPresenter = injector.getByToken(KpFavouritesButtonPresenter.presenterName);

    let showAddButton = false;
    let showRemoveButton = false;
    let isDisabled = true;

    const statesSubscription = presenter.getFavouritesState$().subscribe((state) => updateButtonsDisabledState(state));

    onDestroy(() => {
        statesSubscription.unsubscribe();
    });

    function updateButtonsDisabledState(state: State) {
        isDisabled = state === states.PROCESSING || state === states.INITIAL;
        if (state === states.NORMAL) {
            showAddButton = presenter.canAddToFavourites(record);
            showRemoveButton = presenter.canRemoveFromFavourites(record);
        }
    }

    async function addToFavourites() {
        await presenter.addToFavourites(record);
    }

    async function removeFromFavourites() {
        await presenter.removeFromFavourites(record);
    }
</script>

<template>
    {#if showAddButton}
        <button type="button"
                class="btn btn-default btn-xs btn-block add-to-favourites-button"
                use:disabledWhen={isDisabled}
                on:click={addToFavourites}>
            <span class="glyphicon glyphicon-heart-empty"></span>
            {localize(/* @kp-localization recordCollections.favourites.AddToFavourites */ 'recordCollections.favourites.AddToFavourites')}
        </button>
    {/if}

    {#if showRemoveButton}
        <button type="button"
                class="btn btn-default btn-xs btn-block remove-from-favourites-button"
                use:disabledWhen={isDisabled}
                on:click={removeFromFavourites}>
            <span class="glyphicon glyphicon-heart"></span>
            {localize(/* @kp-localization recordCollections.favourites.RemoveFromFavourites */ 'recordCollections.favourites.RemoveFromFavourites')}
        </button>
    {/if}
</template>

<style lang="less">
  .remove-from-favourites-button {
    visibility: visible; /* tlacitko odebrat je viditelne porad (ne jen kdyz se najede na nejaky jeho kontejner) */
  }
</style>